import { CreateNewInvoiceMenuItem } from "./components";

export function HeaderMenuItem() {
  return <></>;
}

HeaderMenuItem.CreateNewInvoice = CreateNewInvoiceMenuItem;
